import { GoalState } from "reducers/goal-slice/type";
import { PayloadAction } from "@reduxjs/toolkit";

export function updateGoalIdsReducer(state: GoalState, action: PayloadAction<number[]>): void {
  state.goalIds = action.payload;
}
